import { formatDate } from "../../../../utils";

export class EventoFiscal {
  descricaoEvento = null;
  codigoEvento = null;
  dataPrevistaEntrega = null;
  fatNfSaidaId = null;
  chaveAcesso = null;
  estNfEntradaId = null;
  aceiteCreditoDebitoNota = null;
  itens = [];

  constructor(dadosEvento) {
    this.descricaoEvento = dadosEvento.descricaoEvento;
    this.codigoEvento = dadosEvento.codigoEvento;
    this.dataPrevistaEntrega = dadosEvento.dataPrevistaEntrega
      ? formatDate.toSend(new Date(dadosEvento.dataPrevistaEntrega))
      : null;
    this.fatNfSaidaId = dadosEvento.fatNfSaidaId;
    this.chaveAcesso = dadosEvento.chaveAcesso;
    this.estNfEntradaId = dadosEvento.estNfEntradaId;
    this.aceiteCreditoDebitoNota = dadosEvento.aceiteCreditoDebitoNota;
    this.itens = dadosEvento.itens || [];
  }
}
